import React from "react";

const IPin = ({
  color = "#FD4949",
  width = "16",
  height = "16",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M5.36151 2.26887C6.97974 1.27366 9.02061 1.27366 10.6388 2.26887C13.1849 3.83482 13.8148 7.26097 11.9924 9.6302L8.39666 14.3047C8.30201 14.4277 8.15541 14.5 8.00018 14.5C7.84494 14.5 7.69834 14.4277 7.60369 14.3047L4.00799 9.6302C2.18551 7.26097 2.81546 3.83482 5.36151 2.26887ZM10.1148 3.12044C8.81787 2.3229 7.18249 2.3229 5.88559 3.12044C3.84501 4.3754 3.33981 7.12131 4.80031 9.02018L8.00018 13.179L11.2 9.02018C12.6605 7.12131 12.1553 4.3754 10.1148 3.12044Z"
        fill={color}
      />
      <path
        d="M5.62328 2.69439C7.08077 1.79803 8.91898 1.79815 10.3765 2.69439C12.6699 4.10484 13.2375 7.19117 11.5959 9.32525L8.00023 13.9997L4.40453 9.32525C2.76295 7.1912 3.32995 4.10487 5.62328 2.69439ZM8.00023 4.49973C6.80361 4.49973 5.83357 5.46978 5.83356 6.66639C5.83356 7.86301 6.80361 8.83306 8.00023 8.83306C9.19682 8.83303 10.1669 7.86299 10.1669 6.66639C10.1669 5.4698 9.19682 4.49975 8.00023 4.49973Z"
        fill={color}
      />
    </svg>
  );
};

export default IPin;
